import React, { useState, useEffect } from 'react';

import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from '../ui-components/BaseModal';
import { secondsToMinutesAndSeconds } from 'flow/utils/date-time-utils';
import BaseInput from '../ui-components/BaseInput';

interface Props {
    serviceLevel?: number;
    onDurationChanged?: (duration: number) => void;
}

const DurationPickerModal = ({ serviceLevel, onDurationChanged }: Props) => {
    const { i18next } = useAppContext();
    const { m, s } = secondsToMinutesAndSeconds(serviceLevel);

    const [minutes, setMinutes] = useState(m);
    const [seconds, setSeconds] = useState(s);
    const [isValidTime, setIsValidTime] = useState(false);

    useEffect(() => {
        const validTime =
            minutes < 0 || minutes > 59 || seconds < 0 || seconds > 59;
        setIsValidTime(!validTime);
    }, [minutes, seconds]);

    const onAccept = () => {
        // If minutes or seconds is empty string we should send 0 as value in handleAccept
        const min = minutes || 0;
        const sec = seconds || 0;
        onDurationChanged(min * 60 + sec);
    };

    return (
        <BaseModal
            open={true}
            header={i18next.t('Queue.Statistics.ServiceLevel.Title')}
            onSubmit={onAccept}
            disableSubmit={!isValidTime}
        >
            <BaseInput
                type="number"
                label={i18next.t('duration.min')}
                value={minutes}
                onChange={(event) => setMinutes(parseInt(event.target.value))}
            />
            <BaseInput
                type="number"
                label={i18next.t('duration.sec')}
                value={seconds}
                onChange={(event) => setSeconds(parseInt(event.target.value))}
            />
        </BaseModal>
    );
};

export default DurationPickerModal;
